var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "news" },
    [
      _c("NewsContainer", {
        attrs: {
          "show-municipality-selection": _vm.showMunicipalitySelection,
          "selected-municipality-id": _vm.municipalityId,
          "excluded-news-item-id": _vm.excludedNewsItemId,
          "news-api-url": _vm.newsApiUrl,
          "municipality-api-url": _vm.municipalityApiUrl
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }